/* eslint-disable react/jsx-pascal-case */
import React from "react";
import ReactTimeAgo from "react-time-ago";
import Card from "@material-ui/core/Card";
import Dialog from "@material-ui/core/Dialog";
import ErrorIcon from "@material-ui/icons/Error";
import { Palette, API_BASE } from "../AppConfig";
import Typography from "@material-ui/core/Typography";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { useSelector, useDispatch } from "react-redux";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import BSL_StatusChip from "../components/BSL_StatusChip";
import JobStatusTooltip from "../components/JobStatusTooltip";
import CardActionArea from "@material-ui/core/CardActionArea";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { ContextMenu, ContextMenuItem } from "../components/BSL_ContextMenu";
import BSL_Dialog from "../components/BSL_Dialog";
import { updateAPP, MAIN_PAGE, updateUserFromWeb } from "../redux_store/appState";
import { changePage, DESIGNER_PAGE, saveUserToWeb } from "../redux_store/appState";
import {
    updateDesigner,
    resetDesigner,
    SHOW_LOADING_BACKDROP,
    setDesignerLoadingBackdrop,
} from "../redux_store/appState";
import { loadJob, updateJobErp } from "../redux_store/jobState";
import BSL_Button from "../components/BSL_Button";
import { Badge, Box, CircularProgress, Popover, Tooltip } from "@material-ui/core";
import { updateJobStatus } from "../redux_store/jobState";
import { BaseURL } from "../components/Common";
import ARViewCountChip from "./ARViewCountChip";
import { ErpEditorInternal } from "./ErpTable";

const styles = {
    card: {
        flex: "1",
        margin: "15px",
        display: "flex",
        position: "relative",
        flexDirection: "column",
        border: `1px solid white`,
        transition: "border .15s ease-in, opacity .15s ease-in-out",
        opacity: 0,
        animation: "$fadeIn .5s ease-in-out forwards",
    },
    LysaghtCard: {
        "&:hover": {
            border: `1px solid ${Palette.Lysaght.DarkBlue}`,
        },
    },
    cardWidthLimit: {
        maxWidth: 500,
        minWidth: 300,
    },
    media: {
        // ⚠︝ object-fit is not supported by IE 11.
        objectFit: "contain",
        width: "128px",
        height: "128px",
        "&:hover": {
            backgroundColor: Palette.Control.LightGrey,
        },
    },
    content: {
        flex: "1",
        display: "flex",
        textAlign: "left",
        flexDirection: "column",
    },
    contentLysaght: {
        "& h3": {
            font: "600 14pt " + Palette.Lysaght.FontFamily,
            textTransform: "uppercase",
            color: Palette.Lysaght.DarkBlue,
        },
        "& p": {
            font: "200 0.85rem / 1.5 " + Palette.Lysaght.FontFamily,
        },
    },
    typography: {
        margin: "20px",
    },
    actionblock: {
        bottom: "0px",
        backgroundColor: Palette.Control.LightGrey,
        fontSize: "11px",
        display: "flex",
    },
    moreButton: {
        padding: "0px",
        borderRadius: "0%",
    },
    orderDetailsBG: {
        width: "0px",
        height: "0",
        borderLeft: "241px solid transparent",
        borderBottom: "60px solid #dedfe5",
        position: "absolute",
        bottom: "31px",
        right: "0px",
    },
    orderDetails: {
        position: "absolute",
        bottom: "33px",
        right: "5px",
        zIndex: "2",
        color: "black",
        cursor: "pointer",
        textAlign: "right",
    },
    backdropLoader: {
        position: "absolute",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: "100",
        background: "#c4c3cf66",
    },
    // add keyframes for animation
    "@keyframes fadeIn": {
        "0%": {
            opacity: 0,
        },
        "100%": {
            opacity: 1,
        },
    },
};

function JobCard(props) {
    const { classes, row, businessCode } = props;

    const dispatch = useDispatch();
    const [simpleDialogOpen, setSimpleDialogOpen] = React.useState(false); // was `open`
    const [updating, setUpdating] = React.useState(false);
    const [deleteKey, setDeleteKey] = React.useState(null);
    // use persistent wrapper ref as anchor
    const erpAnchorRef = React.useRef(null);
    const [erpAnchorEl, setErpAnchorEl] = React.useState(null);
    const erpOpen = Boolean(erpAnchorEl);

    const [jobDeletion, setJobDeletion] = React.useState(false);
    const [menuAnchor, setMenuAnchor] = React.useState(null);
    const [loadingJobClicked, setLoadingJobClicked] = React.useState(false);

    const erpNumbers = row?.ErpNumbers || [];
    const [editedErpNumbers, setEditedErpNumbers] = React.useState(erpNumbers);

    // keep editedErpNumbers in sync if row.ErpNumbers changes
    React.useEffect(() => {
        setEditedErpNumbers(row?.ErpNumbers || []);
    }, [row?.ErpNumbers]);

    const app = useSelector((state) => state.app);
    const config = useSelector((state) => state.config);
    const { user, logged_user_code } = app;

    let business_code = user?.BusinessDetails?.Code;
    if (businessCode) business_code = businessCode;

    const handleSimpleDialogOpen = (e) => {
        setSimpleDialogOpen(true);
    };

    const handleSimpleDialogClose = (e) => {
        setSimpleDialogOpen(false);
    };

    const handleMenuClick = (event) => {
        event.stopPropagation();
        setMenuAnchor(event.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handlePinJob = () => {
        handleMenuClose();

        // Update User State With Pinned / UnPinned
        dispatch(updateUserFromWeb(logged_user_code)).then((user_data) => {
            let pinned_jobs = user_data?.pinned_jobs ?? [];
            const selectedJob = row.id;

            // Check if user pinned already
            if (pinned_jobs.includes(selectedJob)) {
                // Remove Pinned Job and save user data, through filter
                // (can be changed to indexing, for performance improvements)
                pinned_jobs = pinned_jobs.filter((e) => e !== selectedJob);
            } else {
                pinned_jobs.push(selectedJob);
            }

            let new_user_data = {
                ...user_data,
                pinned_jobs,
            };

            dispatch(saveUserToWeb(new_user_data, true, false));
        });
    };

    const handleDuplicateQuote = () => {
        if (!business_code) return;

        if (!config?.id || !config?.roofsheet_types) {
            alert("Configuration not fully loaded yet ... please wait a moment and try again.");
        } else {
            dispatch(loadJob(business_code, row.id, user)).then(() => {
                dispatch(updateAPP(MAIN_PAGE, { page: "Duplicate" }));
            });
        }
    };

    const deleteQuoteAsk = () => {
        setDeleteKey(true);
        setJobDeletion(true);
    };

    // open ERP popover anchored to the persistent wrapper; fallback to event.currentTarget
    const handleErpOpen = (event) => {
        if (event && typeof event.stopPropagation === "function") event.stopPropagation();
        // prefer persistent wrapper if present, otherwise fallback
        setErpAnchorEl(erpAnchorRef.current || (event && event.currentTarget) || null);
    };

    const handleErpClose = (event) => {
        if (event && typeof event.stopPropagation === "function") event.stopPropagation();
        setErpAnchorEl(null);
    };

    const handleErpSave = (event) => {
        if (event && typeof event.stopPropagation === "function") event.stopPropagation();
        if (!business_code) return;
        setUpdating(true);
        setDeleteKey(false);
        dispatch(updateJobStatus(business_code, row.id, "DELETED")).then(setUpdating(false));
        dispatch(updateJobErp(business_code, row.id, editedErpNumbers)).then(() => {
            setUpdating(false);
            setErpAnchorEl(null);
        });
    };

    const deleteJob = () => {
        setUpdating(true);
        setDeleteKey(false);
        dispatch(updateJobStatus(business_code, row.id, "DELETED")).then(() => setUpdating(false));
    };
    const archiveJob = () => {
        setUpdating(true);
        dispatch(updateJobStatus(business_code, row.id, row.Status === "ARCHIVED" ? "LEAD" : "ARCHIVED")).then(
            setUpdating(false)
        );
    };

    const mainAction = () => {
        if (!jobDeletion) {
            if (!business_code) return;
            if (loadingJobClicked) return;
            setLoadingJobClicked(true);

            dispatch(changePage(DESIGNER_PAGE));
            dispatch(setDesignerLoadingBackdrop("Loading #" + row.id + " - " + row.Customer.JobName));
            dispatch(loadJob(business_code, row.id, user, props?.containerMode ? props?.containerMode : "")).then(
                (result) => {
                    if (!result) {
                        dispatch(
                            setDesignerLoadingBackdrop(
                                <div onClick={() => mainAction()}>
                                    <ErrorIcon style={{ fontSize: 40, color: "#ffa8a8" }} />
                                    <br />
                                    <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                                        <span>
                                            Error Loading # {row.id} - {row.Customer.JobName} ... try again?
                                        </span>
                                    </Typography>
                                </div>
                            )
                        );
                        setLoadingJobClicked(false);
                    } else {
                        dispatch(updateDesigner(SHOW_LOADING_BACKDROP, false));
                        dispatch(resetDesigner());
                        setLoadingJobClicked(false);
                    }
                }
            );
        }

        if (jobDeletion) setJobDeletion(false);
    };

    let date = new Date(row?.LastEditor?._ts ?? row._ts * 1000); // Default back to document change date
    let image_url = API_BASE() + "svg/" + row.id + "/layout.svg";
    let actions = null;
    let job_name = row && row?.Customer?.JobName ? row?.Customer?.JobName : "[Unnamed]";
    let ordered_time = "";

    if (row.OrderTimestamp)
        ordered_time = (
            <>
                <br />
                Ordered&nbsp;{row?.OrderBy ? "by " + row?.OrderBy + " " : ""}
                <ReactTimeAgo date={row.OrderTimestamp} locale="en-AU" timeStyle="round" />
            </>
        );

    actions = (
        <CardActions onClick={() => (mainAction ? mainAction() : null)} className={classes.actionblock}>
            <div style={{}}>#{row.id}</div>
            <div
                style={{
                    flex: "1",
                    textAlign: "right",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                }}
            >
                Last Edited&nbsp;{row?.UserCode ? "by " + row?.UserCode + " " : ""}
                <ReactTimeAgo date={date} locale="en-AU" timeStyle="round" />
                {ordered_time}
            </div>
        </CardActions>
    );

    let preprod = (
        <CardActions
            style={{
                backgroundColor: window.brand === "Fielders" ? Palette.FieldersBlue : Palette.Lysaght.DarkBlue,
                color: "white",
            }}
            onClick={() => (mainAction ? mainAction() : null)}
            className={classes.actionblock}
        >
            <div style={{ flex: 1, textAlign: "center" }}>CREATED IN PREPROD</div>
        </CardActions>
    );

    const orderStatus = (row?.OrderStatus || "").toUpperCase();
    let order_text = row?.OrderStatus?.toUpperCase();
    let bg_color = "#dedfe5";

    if (orderStatus === "REVIEWED") bg_color = "darkorange";
    if (orderStatus === "ACCEPTED") bg_color = "#008200";

    let disableDelete = false;

    if (
        orderStatus === "ORDERED'" ||
        orderStatus === "PENDING" ||
        orderStatus === "REVIEWED" ||
        orderStatus === "ACCEPTED"
    ) {
        disableDelete = true;
    }

    return (
        <Card
            onClick={() => (mainAction ? mainAction() : null)}
            className={
                classes.card +
                (props.noMaxWidth ? "" : " " + classes.cardWidthLimit) +
                (window.brand === "Fielders" ? "" : " " + classes.LysaghtCard)
            }
            style={props.disabled ? { opacity: "0.5" } : {}}
        >
            {row?.preprod === true && preprod}
            {updating && (
                <div className={classes.backdropLoader}>
                    <CircularProgress color="inherit" style={{ position: "absolute" }} />
                </div>
            )}

            {orderStatus.length > 0 && (
                <>
                    {user.Role >= 90 && orderStatus === "ACCEPTED" && <JobStatusTooltip row={row} />}
                    <div
                        className={classes.orderDetailsBG}
                        onClick={() => (mainAction ? mainAction() : null)}
                        style={{
                            borderBottom: "60px solid " + bg_color,
                            marginBottom: ordered_time ? "16px" : "0px",
                        }}
                    ></div>

                    {/* Persistent wrapper used as the anchor for Popover */}
                    <div
                        ref={erpAnchorRef}
                        className={classes.orderDetails}
                        onClick={
                            editedErpNumbers.length === 0 && orderStatus === "ACCEPTED"
                                ? () => (mainAction ? mainAction() : null)
                                : undefined
                        }
                        style={
                            editedErpNumbers.length > 0 && orderStatus === "ACCEPTED"
                                ? {
                                      color: "white",
                                      alignItems: "end",
                                      display: "flex",
                                      flexDirection: "column",
                                      bottom: editedErpNumbers.length - 1 >= 0 && !ordered_time ? "33px" : "48px",
                                  }
                                : orderStatus === "REVIEWED" || orderStatus === "ACCEPTED"
                                ? {
                                      color: "white",
                                      marginBottom: ordered_time ? "16px" : "0px",
                                  }
                                : { marginBottom: ordered_time ? "16px" : "0px" }
                        }
                    >
                        {editedErpNumbers.length > 0 && orderStatus === "ACCEPTED" ? (
                            <Tooltip
                                title={
                                    <>
                                        {editedErpNumbers.map((num, idx) => (
                                            <div key={idx}>{num}</div>
                                        ))}
                                    </>
                                }
                                arrow
                            >
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "end" }}>
                                    <button
                                        style={{
                                            width: "20px",
                                            borderRadius: "99px",
                                            cursor: "pointer",
                                            border: "1px solid gray",
                                            backgroundColor: "#0d9d19",
                                        }}
                                        disabled={user?.Role < 90}
                                        onClick={(e) => {
                                            // open anchored popover
                                            e.stopPropagation();
                                            handleErpOpen(e);
                                        }}
                                    >
                                        <span style={{ color: "white", fontWeight: "bolder" }}>+</span>
                                    </button>
                                    <span style={{ fontSize: "14px" }}>{editedErpNumbers[0]}</span>
                                    {editedErpNumbers.length - 1 > 0 && (
                                        <span style={{ fontSize: "8px" }}>+{editedErpNumbers.length - 1} Orders</span>
                                    )}
                                    {editedErpNumbers.length - 1 === 0 && (
                                        <span style={{ fontSize: "8px" }}>&nbsp;</span>
                                    )}
                                </div>
                            </Tooltip>
                        ) : (
                            <>
                                {orderStatus === "ACCEPTED" && (
                                    <button
                                        style={{
                                            width: "20px",
                                            borderRadius: "99px",
                                            cursor: "pointer",
                                            border: "1px solid gray",
                                            backgroundColor: "#0d9d19",
                                        }}
                                        disabled={user?.Role < 90}
                                        onClick={(e) => {
                                            // open anchored popover
                                            e.stopPropagation();
                                            handleErpOpen(e);
                                        }}
                                    >
                                        <span style={{ color: "white", fontWeight: "bolder" }}>+</span>
                                    </button>
                                )}
                                <div>
                                    ORDER
                                    <br />
                                    {order_text}
                                </div>
                            </>
                        )}
                    </div>

                    {/* ERP Popover (inline editor) */}
                    <Popover
                        open={erpOpen}
                        anchorEl={erpAnchorEl}
                        onClose={(e) => {
                            handleErpSave(e);
                            // Popover onClose gets event and reason; keep it simple:
                            if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                            setErpAnchorEl(null);
                        }}
                        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                        popperOptions={{
                            strategy: "fixed",
                            modifiers: [
                                { name: "eventListeners", options: { scroll: false, resize: false } },
                                { name: "flip", options: { enabled: false } },
                            ],
                        }}
                        transformOrigin={{ vertical: "top", horizontal: "center" }}
                        PaperProps={{ style: { padding: "16px", minWidth: 300 } }}
                        // prevent card click when interacting inside popover
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                    >
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                            <ErpEditorInternal
                                prefix={row?.DistributorPOA}
                                initialErpNumbers={editedErpNumbers}
                                onChange={setEditedErpNumbers}
                                dispatch={dispatch}
                            />
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px" }}>
                                <button
                                    onClick={(e) => {
                                        handleErpSave(e);
                                        if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                                        setErpAnchorEl(null);
                                    }}
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </Popover>
                </>
            )}
            <CardActionArea
                style={{
                    display: "flex",
                    flex: "1",
                    alignItems: "flex-start",
                }}
            >
                <object
                    className={classes.media}
                    data={image_url}
                    type="image/png"
                    onClick={(e) => {
                        handleSimpleDialogOpen();
                        e.stopPropagation();
                    }}
                >
                    <img
                        className={classes.media}
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                        alt="Thumbnail"
                    />
                </object>
                {row && (
                    <CardContent className={classes.content + (window.LYSAGHT ? " " + classes.contentLysaght : "")}>
                        <div style={{ flex: 1 }}>
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <h3
                                    style={{
                                        margin: "0px",
                                        flex: 1,
                                        textOverflow: "ellipsis",
                                        width: "100px",
                                        overflow: "hidden",
                                        WebkitLineClamp: 2,
                                    }}
                                >
                                    {job_name}
                                </h3>
                                <div
                                    className={classes.moreButton}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleMenuClick(e);
                                    }}
                                >
                                    <MoreVertIcon />
                                </div>
                            </div>
                            <Typography component="p" variant="caption" style={{ color: "#4e4e4e", textAlign: "left" }}>
                                {row.DesignSummary ? row.DesignSummary : "[No Design Summary]"}
                                <br />
                                {row.FormattedAddress ? row.FormattedAddress : "[No Address]"}
                            </Typography>
                        </div>

                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                            {row.Status !== "ARCHIVED" && (
                                <BSL_StatusChip history={row.History} status={row.Status} job_id={row.id} />
                            )}
                            <div style={{ display: "flex", justifyContent: "end" }}>
                                {row.pinned && <img alt="pin" src={BaseURL("/images/ly-pin.svg")} />}
                            </div>
                        </div>
                    </CardContent>
                )}
            </CardActionArea>
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    flexDirection: "row",
                }}
            >
                <div
                    style={{
                        flex: 1,
                        height: "40px",
                    }}
                >
                    {row?.DOrderStatus && (
                        <div
                            style={{
                                paddingLeft: 10,
                                display: "flex",
                                justifyContent: "flex-start",
                                flexDirection: "column",
                                flex: 1,
                            }}
                        >
                            <span>D365 Status</span>
                            <span style={{ fontWeight: "bold" }}>{row.DOrderStatus}</span>
                        </div>
                    )}
                </div>
                <div
                    style={{
                        flex: 1,
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                    }}
                >
                    {orderStatus.length === 0 && <ARViewCountChip job={row} classes={classes} />}
                </div>
            </div>
            {actions}
            <SimpleDialog
                image_url={image_url}
                open={simpleDialogOpen}
                onClose={handleSimpleDialogClose}
                mainAction={mainAction}
            />

            <ContextMenu
                onClick={(e) => {
                    e.stopPropagation();
                }}
                id="customized-menu"
                menuAnchor={menuAnchor}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                disableScrollLock={true}
            >
                <ContextMenuItem onClick={handlePinJob}>Pin / UnPin</ContextMenuItem>
                {user.Role >= 90 && orderStatus === "ACCEPTED" && (
                    <ContextMenuItem
                        onClick={(e) => {
                            e.stopPropagation();
                            // open erp popover from menu if clicked (falls back to event.currentTarget)
                            handleErpOpen(e);
                        }}
                    >
                        ERP Numbers
                    </ContextMenuItem>
                )}
                <ContextMenuItem onClick={handleDuplicateQuote} disabled={!business_code}>
                    Duplicate Job
                </ContextMenuItem>
                <ContextMenuItem onClick={archiveJob}>
                    {row.Status === "ARCHIVED" ? "Un-Archive" : "Archive"} Job
                </ContextMenuItem>
                <ContextMenuItem onClick={deleteQuoteAsk} disabled={disableDelete}>
                    Delete Job
                </ContextMenuItem>
            </ContextMenu>

            <BSL_Dialog
                title="Delete Job?"
                open={deleteKey}
                onClose={() => setDeleteKey(false)}
                button1Text="Delete"
                button1Click={(e) => {
                    if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                    deleteJob();
                }}
                button2Text="No"
                button2Click={(e) => {
                    if (e && typeof e.stopPropagation === "function") e.stopPropagation();
                    setDeleteKey(false);
                }}
            >
                <div style={{ display: "flex" }}>
                    <div>Are you sure you would like to delete this job ({job_name})?</div>
                </div>
            </BSL_Dialog>
        </Card>
    );
}

export default withStyles(styles)(JobCard);

const useStyles = makeStyles({
    root: {},
    media: {
        // ⚠︝ object-fit is not supported by IE 11.
        objectFit: "contain",
        width: "93%",
        height: "93%",
        padding: "10px 20px",
    },
});

function SimpleDialog(props) {
    const classes = useStyles();
    const { onClose, selectedValue, open, image_url, mainAction } = props;

    const handleClose = () => {
        onClose();
    };

    return (
        <Dialog
            PaperProps={{ style: { width: "80%", height: "80%", maxWidth: "80%" } }}
            onClose={handleClose}
            aria-labelledby="simple-dialog-title"
            open={open}
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <object className={classes.media} data={image_url} type="image/png" onClick={handleClose}>
                <img
                    className={classes.media}
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAikAAAEYBAMAAABrc3u4AAAALHRFWHRDcmVhdGlvbiBUaW1lAFdlZCAyNyBNYXIgMjAxOSAxODo1MTo0NyArMDkzMOWZz+IAAAAHdElNRQfjAxsIHCk2av1LAAAACXBIWXMAAAsSAAALEgHS3X78AAAABGdBTUEAALGPC/xhBQAAAANQTFRFlJylJii/hwAAAGJJREFUeNrtwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB4NDAfAAHd3L3XAAAAAElFTkSuQmCC"
                    alt="Stack Overflow logo and icons and such"
                />
            </object>
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <BSL_Button
                    label="Open Job"
                    onClick={() => {
                        if (mainAction) mainAction();
                        handleClose();
                    }}
                    style={{ marginRight: "10px" }}
                />
                <BSL_Button secondary label="Close" onClick={handleClose} style={{ marginLeft: "10px" }} />
            </div>
        </Dialog>
    );
}
